import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  unsavedChangesDialogContent: {
    color: theme.palette.text.secondary
  },
  addButtonLabel: {
    color: theme.palette.secondary.dark,
    textTransform: "none",
    fontSize: 16,
    "&.disabled": {
      color: theme.palette.text.disabled
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 12
    }
  },
  addButtonEndIcon: {
    color: theme.palette.secondary.dark,
    "&.disabled": {
      color: theme.palette.text.disabled
    },
    "& .MuiSvgIcon-root": {
      fontSize: 26,
      [theme.breakpoints.down("sm")]: {
        fontSize: 19
      }
    }
  },
  horseName: {
    fontSize: 16,
    marginTop: 0,
    marginBottom: 20,
    lineHeight: "normal"
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 20
  },
  selectRoot: {
    fontSize: 12
  },
  selectPlaceholder: {
    fontSize: 12,
    color: theme.palette.text.hint
  },
  inputRoot: {
    fontSize: 12
  },
  inputFocused: {
    "&$inputRoot .MuiOutlinedInput-notchedOutline": {
      borderColor: "#cccccc"
    }
  },
  inputNotchedOutline: {
    "& span": {
      whiteSpace: "nowrap",
      fontSize: 10
    }
  },
  inputAdornedEnd: {
    paddingRight: 4
  },
  inputLabelRoot: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    "&.MuiInputLabel-outlined.MuiInputLabel-marginDense": {
      transform: "translate(14px, 12px) scale(1)"
    }
  },
  inputLabelShrink: {
    "&.MuiInputLabel-outlined.MuiInputLabel-shrink": {
      fontSize: 10,
      transform: "translate(14px, -6px) scale(1)",
      color: theme.palette.text.secondary
    }
  },
  datePicker: {
    lineHeight: "normal",
    fontSize: 12
  },
  commentLabel: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    margin: 0,
    marginBottom: 10,
    lineHeight: "normal"
  },
  commentLabelNote: {
    color: "#cccccc"
  },
  buttonRoot: {
    width: 140,
    height: 32,
    borderRadius: 2
  },
  buttonLabel: {
    color: theme.palette.text.secondary
  },
  buttonAdd: {
    backgroundColor: theme.palette.secondary.dark,
    "& $buttonLabel": {
      color: theme.palette.common.white
    },
    "&$buttonRoot:hover": {
      backgroundColor: "#51a584"
    }
  },
  buttonAddDisabled: {
    opacity: 0.5
  },
  subtitle: {
    color: theme.palette.text.hint
  },

  addBoosterButtonRoot: {
    borderRadius: 15,
    height: 30,
    borderColor: theme.palette.secondary.dark
  },
  addBoosterButtonLabel: {
    fontSize: 13,
    textTransform: "none",
    color: theme.palette.secondary.dark
  },
  buttonEditEntry: {
    color: theme.palette.text.secondary,
    fontWeight: "bold"
  },
  actions: {
    display: "flex",
    justifyContent: "right",
    padding: "20px 0 0 0",
    gap: 12
  }
}));
